import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "row items-center" }
const _hoisted_2 = ["src", "alt"]

import { Icons } from "src/util/enums/fontAwesomeIcons"
import {
  determineProfilePictureColor,
  extractInitials,
  getContrastingColorForBackground,
} from "src/util/functions/misc"
import { UserWithAvatar } from "src/util/types/dataModels/user"
import { computed, PropType } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits

const USER_ICON_SIZE = "18px"

export default /*#__PURE__*/_defineComponent({
  __name: 'SfxUserData',
  props: {
  userData: {
    type: Object as PropType<UserWithAvatar>,
  },

  userNameClasses: {
    type: Array as PropType<Array<string>>,
  },

  avatarSize: {
    type: String,
    default: "24px",
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const { t } = useI18n()

const user = computed<UserWithAvatar | null>(() => props.userData || null)
const userName = computed(() => getUserName(user.value))
const userProfilePicture = computed<string | null>(() => props.userData?.avatar || null)
const initials = computed(() => (userName.value ? extractInitials(userName.value) : null))
const profilePictureColor = computed(() =>
  initials.value ? determineProfilePictureColor(initials.value) : "grey"
)
const initialsColor = computed(() => {
  if (!initials.value) return
  const color = getContrastingColorForBackground(profilePictureColor.value)
  return `color: ${color}`
})

//endregion

//region Functions

function getUserName(user: UserWithAvatar | null) {
  if (user === null) {
    return t("sfxCard.system_user")
  } else {
    const username =
      user.first_name && user.last_name ? user.first_name + " " + user.last_name : user.email
    if (username.trim() === "") {
      return t("sfxCard.error_user")
    }
    return username
  }
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_avatar = _resolveComponent("q-avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (user.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_q_avatar, {
            size: props.avatarSize,
            color: profilePictureColor.value,
            class: "sfx-user-data"
          }, {
            default: _withCtx(() => [
              (userProfilePicture.value)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: userProfilePicture.value,
                    alt: _ctx.$t('sfxUserDisplay.profile_picture')
                  }, null, 8, _hoisted_2))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (initials.value)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "sfx-user-data__initials",
                          style: _normalizeStyle(initialsColor.value)
                        }, _toDisplayString(initials.value), 5))
                      : (_openBlock(), _createBlock(_component_q_icon, {
                          key: 1,
                          name: _unref(Icons).USER_CIRCLE,
                          size: USER_ICON_SIZE
                        }, null, 8, ["name"]))
                  ], 64))
            ]),
            _: 1
          }, 8, ["size", "color"]),
          _createElementVNode("div", {
            class: _normalizeClass(["flex items-center q-ml-sm ellipsis", props.userNameClasses])
          }, _toDisplayString(userName.value), 3)
        ], 64))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["flex items-center ellipsis text-italic text-bold text-fun-label-and-icon", props.userNameClasses])
        }, _toDisplayString(userName.value), 3))
  ]))
}
}

})